import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import React from "react";
import { useNavigate, useLocation } from "react-router";
interface DialogAlertProps {
  open: boolean;
  title: string;
  text: string;
  handleClose: () => void;
}
const DialogAlert: React.FC<DialogAlertProps> = ({ open, title, text, handleClose }: DialogAlertProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("modal", "true");
    navigate({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
    return () => {
      searchParams.delete("modal");
      navigate({
        pathname: location.pathname,
        search: searchParams.toString(),
      });
    };
  }, [history]);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{text}</DialogContentText>
          <DialogActions>
            <Button onClick={handleClose} color="primary" variant="contained">
              ok
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DialogAlert;
